import SmartAlertTemplate from '@/components/SmartAlertTemplate';
import { smartAlertPageMap } from '@/data/smartAlertPages';

const page = smartAlertPageMap['money-and-gifts'];

if (!page) {
  throw new Error('Smart alert data missing for money & gifts');
}

const SmartAlertMoneyGifts = () => {
  return <SmartAlertTemplate page={page} />;
};

export default SmartAlertMoneyGifts;


